<script>
import BusienssService from "@/services/Business";
import Customers from "@/services/Customers";
import Swal from "sweetalert2";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import _ from "underscore";
export default {
    props: {
      businessMemberData: {
            type: Object,
        },
      externalProviderData:{
        type: String
      }
    },
  components: {
      VueBootstrapTypeahead,
  },
  data() {
    return {
        externalProvider:[],
        tryingToEdit: false,
        selectedExternalProvider:null,
        errorMessage:'',
        externalUserData:[],
        externalUserSearch:'',
        externalUserNotFoundShow: false,
        searchedUserEmail:'',
        showForm:false,
        loading: false,
        isLoadingUser:false


    };
  },
  watch: {
    'externalUserSearch': _.debounce(function(search) { this.getUserExternalProvider(search, 'externalUserSearch') }, 1000),

  },
  methods: {
    async getUserExternalProvider(query) {
      this.isLoadingUser = true;


      if (query.length > 0) {

        try {
          const response = await Customers.getExternalMembers(`search=${this.externalUserSearch.trim()}&exclude_attached=true`)
          const rawData = response.data.data[0];
          if (rawData !== undefined && rawData !== null && rawData !== '') {
            this.selectedExternalProvider = rawData.external_customer_id
            this.searchedUserEmail = rawData.email
            this.externalUserNotFoundShow = false
          }else{
            this.externalUserNotFoundShow = true
            this.selectedExternalProvider = null
          }
        } catch (error) {
          //console.error("Error fetching customers:", error);
        } finally {
          this.isLoadingUser = false;
        }
      }

      this.isLoadingUser = false;
    },
      async getExternalProviders(){
          try {
            this.loading= true
            const email = this.businessMemberData.email
            if(!email){
              console.error('Missing email!')
              this.loading= false
              return
            }
              const response = await BusienssService.getExternalProvider(email)
              this.externalProvider = response.data.data
              this.loading= false
              if(this.externalProvider.length === 0){
                this.showForm = true
                this.externalProvider = null
                this.errorMessage = 'External user with same email not found'
                this.loading= false
                return
              }

          } catch (error) {
              // this.error = error.response.data.error ? error.response.data.error : "";
              this.externalProvider = null
            this.loading= false
          } finally {
              this.toggleBusy();
            this.loading= false

          }
    },

    async saveChanges() {

      if (!this.selectedExternalProvider || !this.businessMemberData.company_id) {
        console.error("Provider data is missing.");
        return;
      }
      this.tryingToEdit = true;
      const payload = {
        customer_id:this.businessMemberData.customer_id,
        external_customer_id: this.selectedExternalProvider,
      };
      try {
        const response = await BusienssService.attachExternalProvider(payload);
        if (response.status >= 200 && response.status < 300) {
          // Emit event for parent to update after save
            this.$emit('onRefresh');  // Emit refreshTable only after saving
          this.$bvModal.hide('attach_external_provider');  // Close the modal after save
          Swal.fire("Success!", "Business Users successfully attached!", "success");
        } else {
          Swal.fire("Fail!", "Error Attaching External Provider", "warning");
        }
      } catch (error) {
        this.tryingToEdit = false;
        let errorMessage = error.response && error.response.data && error.response.data.error
            ? error.response.data.error
            : "Error Attaching External Provider"
        if (typeof errorMessage === 'object') {
          errorMessage = errorMessage[0];
        }
        Swal.fire("Fail!", errorMessage, "warning");
      }

      this.tryingToEdit = false;
    },


    closeModal() {
        // Only hide the modal, no page reload or table refresh here
          this.$bvModal.hide('attach_external_provider');
          this.externalProvider=null,
          this.errorMessage='',
          this.showForm=false
          this.externalUserNotFoundShow = false
          this.externalUserSearch = ''
          this.searchedUserEmail = ''
          this.externalUserData = []
          this.selectedExternalProvider = null
          this.loading= false
          this.isLoadingUser= false
    },
  },
  computed: {
     fullSelect(){
       return this.externalProvider.map(provider =>
           `${provider.name} ${provider.surname} | ${provider.email} | ${provider.external_company_name}`
       );
     }
  },


};
</script>

<template>
  <b-modal id="attach_external_provider" @shown="getExternalProviders" title="Attach External User" @hidden="closeModal"  size="xl" centered>
    <template v-slot:default v-if="externalProvider && !loading">
      <div class="row">
        <div class="col-sm-6">
          <b-form-group label="Select Contact From External Provider">
              <b-form-select
                      v-model="selectedExternalProvider"
                      :options="externalProvider.map(provider => ({ text: fullSelect, value: provider.external_customer_id }))"
                      placeholder="Select an external user"
              >
              </b-form-select>

          </b-form-group>
        </div>
      </div>


    </template>
    <div v-if="showForm && externalProviderData.trim() === 'tymes4'">
      <div v-if="errorMessage">
        <h3 class="text-center text-danger">{{errorMessage}}</h3>
      </div>
      <b-form-group v-if="showForm && externalProviderData.trim() === 'tymes4'" label-for="formrow-external-input" class="mb-3 col-4">
        <label class="typo__label" for="ajax" >Search (email, ticketing number)</label>
        <vue-bootstrap-typeahead  id="formrow-externalUserSearch-input" ref="externalUserSearch"
                                 v-model.trim="externalUserSearch"
                                 :data=externalUserData
                                 />

        <div
            v-if="isLoadingUser"
            class="spinner-border spinner-border-sm text-primary "
        >
          <span class="visually-hidden">Loading...</span>
        </div>
        <div v-if="searchedUserEmail && !externalUserNotFoundShow" class="d-flex flex-column ">
          <span class="d-flex gap-1">Ticketing User Found: <span class="text-success">{{searchedUserEmail}}</span></span>
          <span>Proceed with attachment</span>
        </div>
        <div v-if="externalUserNotFoundShow" class="text-danger mt-1">
          No results found.
        </div>

      </b-form-group>

    </div>

    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeModal">Cancel</b-button>
      <b-button @click="saveChanges" v-if="!externalUserNotFoundShow"  variant="primary"  :disabled="tryingToEdit">Save Changes
        <b-spinner v-show="tryingToEdit" small></b-spinner>
      </b-button>
    </template>
    <div style="display: flex; justify-content: center" v-show="loading">
      <b-spinner class="text-center" v-show="loading" big></b-spinner>
    </div>
  </b-modal>
</template>
